/**
 * Level Bonus Info Composable
 * 等級獎勵資訊管理
 *
 * 架構：
 * - 狀態管理：使用 Pinia store (stores/user/levelBonusInfo.js)
 * - 業務邏輯：保留在 composable 中
 */

import { storeToRefs } from 'pinia'
import { useLevelBonusInfoStore } from '@/stores/user/levelBonusInfo'
import { activityApi } from '@/api'
import { useMainStore } from '@/stores/main'

export const useLevelBonusInfo = () => {
  const { $request } = useNuxtApp()
  const { appSecret } = useRuntimeConfig().public
  const { isLoggedIn } = useAuthToken()

  const store = useLevelBonusInfoStore()
  const { levelBonusInfo } = storeToRefs(store)
  const mainStore = useMainStore()
  const { setModalLoading } = mainStore

  onMounted(async () => {
    try {
      setModalLoading(true)
      await fetchLevelBonusInfo()
    } finally {
      setModalLoading(false)
    }
  })

  // API Methods
  const fetchLevelBonusInfo = async () => {
    if (!isLoggedIn.value) {
      return
    }

    store.setStatus('fetching')
    store.setError(null)

    try {
      const response = await $request.send(activityApi.getLevelBonusInfo({ appSecret }))
      const data = response.data || response
      store.setLevelBonusInfo(data || {})
      store.setStatus('idle')
      return data
    } catch (error) {
      store.setError(error)
      store.setStatus('idle')
      throw error
    }
  }

  return {
    fetchLevelBonusInfo,
    levelBonusInfo,
  }
}
